<template>
  <div id="site">
    <NavBar />
    <Hero />
    <Features />
    <Showcase />
    <Enterprise />
    <Legal />
    <Pricing />
    <FAQ />
    <SiteFooter />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import Hero from './components/Hero.vue'
import Features from './components/Features.vue'
import Showcase from './components/Showcase.vue'
import Enterprise from './components/Enterprise.vue'
import Legal from './components/Legal.vue'
import Pricing from './components/Pricing.vue'
import FAQ from './components/FAQ.vue'
import SiteFooter from './components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    Hero,
    Features,
    Showcase,
    Enterprise,
    Legal,
    Pricing,
    FAQ,
    SiteFooter
  }
}
</script>

<style>
html {
  scroll-behavior: smooth;
}
body {
  margin: 0;
  background: #0b1020;
}
#site {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", "PingFang SC", "Hiragino Sans GB",
    "Microsoft Yahei", sans-serif;
  color: #e5e7eb;
}
</style>
